module.exports = __webpack_public_path__ + "img/img-shipin-s3-tuya.7ddbd0a1.jpg";